import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_italic,
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

// TODO: refactor this to use classNames + stylesheet approach
export const groupHeading = css`
  &.GroupHeading {
    display: flex;
    align-items: center;
    ${font_md};
    font-family: ${font_family_weight_regular};
    color: ${text_colorTextSecondary};
    height: ${spacing(13)};

    &.small {
      padding: ${spacing(2)};
    }

    &.medium {
      padding: ${spacing(2)} ${spacing(5)};
    }
  }
`

export const loadingOption = css`
  &.LoadingOption {
    display: flex;
    align-items: center;
    height: ${spacing(13)};
    margin-left: ${spacing(8)};
    ${font_md};
    font-family: ${font_family_weight_italic};
    color: ${text_colorTextSecondary};

    &.small {
      padding: ${spacing(2)};
    }

    &.medium {
      padding: ${spacing(2)} ${spacing(5)};
    }
  }
`

export const emptyState = css`
  &.DropdownEmptyState {
    padding: ${spacing(4)};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing(5)};
    text-align: center;

    & .title {
      font-family: ${font_family_weight_medium};
      ${font_md}
    }

    & .subtitle {
      ${font_md}
    }
  }
`
